import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  {
    q: "Finally — a health app that doesn't cost ₹3,500/month. My strain/recovery data is more actionable than Whoop ever was.",
    n: "Marcus Chen",
    h: "@marcusfitlife · Coach",
    c: "#FFD4A3",
  },
  {
    q: "Down 5 kg in 10 weeks. Not because I ate less, but because Zoku showed me what was actually in my 'healthy' snacks.",
    n: "Aisha L.",
    h: "Nutritionist, Mumbai",
    c: "#FFB97A",
  },
  {
    q: "The morning recovery score replaced my guesswork. I train hard on green days, rest on red. Zero burnout in 4 months.",
    n: "Rachel Kim",
    h: "Chicago · Mum of 2",
    c: "#FF8F3A",
  },
  {
    q: "Beautiful. Clean. Honest. I wish Apple Health had shipped this in the first place.",
    n: "Dev T.",
    h: "London · Clean-eating",
    c: "#FF6B00",
  },
  {
    q: "The AI coach caught that my deep sleep tanks every Sunday. Turns out, Friday espressos. Fixed it in a week.",
    n: "Sophie B.",
    h: "@sophieskinlab",
    c: "#E56000",
  },
  {
    q: "Bulking for 4 months. Zoku keeps me honest on macros every day. No other app catches the junk ingredients.",
    n: "Tyler J.",
    h: "@tylerliftsheavy",
    c: "#CC4E00",
  },
];

function ReviewCard({ r }) {
  return (
    <div className="shrink-0 w-[360px] md:w-[420px] bg-white rounded-3xl border border-stone-100 shadow-widget p-7 mx-3">
      <div className="flex items-center gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-zoku-orange text-zoku-orange" />
        ))}
      </div>
      <p className="mt-4 text-zoku-ink leading-relaxed text-base md:text-lg">“{r.q}”</p>
      <div className="mt-6 flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold"
          style={{ background: r.c }}
        >
          {r.n
            .split(" ")
            .map((x) => x[0])
            .join("")
            .slice(0, 2)}
        </div>
        <div>
          <div className="font-semibold text-sm text-zoku-ink">{r.n}</div>
          <div className="text-xs text-zoku-ink3">{r.h}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="reviews" className="py-24 md:py-32 bg-zoku-bg overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-zoku-orange mb-4">
            Loved everywhere
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            Real people. <span className="font-editorial text-zoku-orange">Real progress.</span>
          </h2>
          <p className="mt-5 text-lg text-zoku-ink2">
            From weekend runners to Olympic coaches — Zoku is the health OS people wake up to.
          </p>
        </motion.div>

        {/* Stats row */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 max-w-xl mx-auto">
          {[
            { n: "4.8★", l: "App Store" },
            { n: "1M+", l: "Downloads" },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-zoku-ink">{s.n}</div>
              <div className="text-xs md:text-sm text-zoku-ink3 mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee rows */}
      <div className="mt-16 space-y-6">
        <div className="relative overflow-hidden gradient-mask-r">
          <div className="flex animate-marquee">
            {[...reviews, ...reviews].map((r, i) => (
              <ReviewCard key={i} r={r} />
            ))}
          </div>
        </div>
        <div className="relative overflow-hidden gradient-mask-r">
          <div
            className="flex animate-marquee-slow"
            style={{ animationDirection: "reverse" }}
          >
            {[...reviews.slice().reverse(), ...reviews.slice().reverse()].map((r, i) => (
              <ReviewCard key={i} r={r} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
